import { render, staticRenderFns } from "./WarehouseViewExpired.vue?vue&type=template&id=12f6e496&scoped=true"
import script from "./WarehouseViewExpired.vue?vue&type=script&lang=js"
export * from "./WarehouseViewExpired.vue?vue&type=script&lang=js"
import style0 from "./WarehouseViewExpired.vue?vue&type=style&index=0&id=12f6e496&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f6e496",
  null
  
)

export default component.exports